(function () {
  const body = document.body;
  const onScroll = () => body.classList.toggle("scrolled", window.scrollY > 18);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const word = document.querySelector(".word-reveal");
  if (word) {
    const text = word.dataset.words || word.textContent.trim();
    word.textContent = "";
    let letterIndex = 0;
    text.split(" ").forEach((chunk, wordIndex, words) => {
      const wordSpan = document.createElement("span");
      wordSpan.className = "word-block";
      chunk.split("").forEach((char) => {
        const span = document.createElement("span");
        span.className = "letter";
        span.textContent = char;
        span.style.animationDelay = `${letterIndex * 0.035}s`;
        wordSpan.appendChild(span);
        letterIndex += 1;
      });
      word.appendChild(wordSpan);
      if (wordIndex < words.length - 1) word.appendChild(document.createTextNode(" "));
    });
  }

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("in-view");
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16 });
  document.querySelectorAll(".reveal").forEach((el, index) => {
    el.style.setProperty("--reveal-delay", `${Math.min(index % 6, 5) * 55}ms`);
    revealObserver.observe(el);
  });

  const countObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = Number(el.dataset.count || 0);
      const duration = 900;
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        el.textContent = Math.floor(progress * target).toLocaleString();
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      countObserver.unobserve(el);
    });
  }, { threshold: 0.5 });
  document.querySelectorAll("[data-count]").forEach((el) => countObserver.observe(el));

  const purchase = document.querySelector(".purchase-section");
  const selectedImage = document.getElementById("selectedProductImage");
  const purchaseBuyButton = document.getElementById("PurchaseBuyButton");
  const swatches = document.querySelectorAll(".octagon-swatch, .select-color");
  swatches.forEach((button) => {
    button.addEventListener("click", () => {
      const image = button.dataset.image;
      const color = button.dataset.color;
      const url = button.dataset.url;
      if (image && selectedImage) {
        selectedImage.animate(
          [
            { opacity: 0.72, transform: "scale(0.965) rotate(-1deg)" },
            { opacity: 1, transform: "scale(1) rotate(0deg)" }
          ],
          { duration: 420, easing: "cubic-bezier(.2,.8,.2,1)" }
        );
        selectedImage.src = image;
      }
      if (color && purchase) {
        purchase.style.background = `linear-gradient(135deg, #ffffff, ${color}33)`;
        purchase.animate(
          [
            { backgroundPosition: "0% 50%" },
            { backgroundPosition: "100% 50%" }
          ],
          { duration: 520, easing: "ease-out" }
        );
      }
      if (url && purchaseBuyButton) purchaseBuyButton.href = url;
      document.querySelectorAll(".octagon-swatch").forEach((el) => el.classList.toggle("active", el.dataset.name === button.dataset.name));
    });
  });
  document.querySelector(".octagon-swatch")?.classList.add("active");

  const hero = document.querySelector("[data-parallax]");
  const heroWatch = document.querySelector(".hero-watch");
  if (hero && heroWatch && !window.matchMedia("(max-width: 720px)").matches) {
    let tiltX = 0;
    let tiltY = 0;
    hero.addEventListener("mousemove", (event) => {
      const rect = hero.getBoundingClientRect();
      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;
      tiltX = y * -5;
      tiltY = x * 6;
      heroWatch.style.setProperty("--tilt", `rotateX(${tiltX}deg) rotateY(${tiltY}deg)`);
    });
    hero.addEventListener("mouseleave", () => {
      tiltX = 0;
      tiltY = 0;
      heroWatch.style.setProperty("--tilt", "rotateX(0deg) rotateY(0deg)");
    });
    window.addEventListener("scroll", () => {
      const rect = hero.getBoundingClientRect();
      const progress = Math.max(-1, Math.min(1, rect.top / window.innerHeight));
      heroWatch.style.transform = `translateY(${progress * -18}px) scale(1.01) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`;
      document.querySelectorAll(".octagon-shape").forEach((shape, index) => {
        shape.style.transform = `translateY(${progress * (index + 1) * 10}px) rotate(${progress * 8}deg)`;
      });
    }, { passive: true });
  }
})();
